var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalMarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7814 24.5C47.7814 37.7291 37.1282 48.4534 23.9867 48.4534C10.8453 48.4534 0.192047 37.7291 0.192047 24.5C0.192047 11.271 10.8453 0.546692 23.9867 0.546692C37.1282 0.546692 47.7814 11.271 47.7814 24.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5016 37.5553H32.4699C33.2509 37.5553 33.884 36.9222 33.884 36.1412V13.5168C33.884 12.7358 33.2509 12.1028 32.4699 12.1028H15.5016C14.7206 12.1028 14.0876 12.7358 14.0876 13.5168V36.1412C14.0876 36.9222 14.7206 37.5553 15.5016 37.5553ZM32.4699 38.9693H15.5016C13.9397 38.9693 12.6735 37.7031 12.6735 36.1412V13.5168C12.6735 11.9549 13.9397 10.6887 15.5016 10.6887H32.4699C34.0318 10.6887 35.298 11.9549 35.298 13.5168V36.1412C35.298 37.7031 34.0318 38.9693 32.4699 38.9693Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7051 14.8419C23.9818 14.9857 24.1339 15.241 24.0449 15.4123L22.1111 19.1331C22.0221 19.3043 21.7257 19.3266 21.4491 19.1828C21.1725 19.039 21.0204 18.7837 21.1094 18.6124L23.0431 14.8917C23.1321 14.7204 23.4285 14.6982 23.7051 14.8419Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3499 14.6186C23.6271 14.476 23.9268 14.5061 24.0192 14.6859L26.0276 18.5914C26.12 18.7711 25.9702 19.0324 25.6929 19.1749C25.4157 19.3175 25.116 19.2874 25.0236 19.1076L23.0152 15.2022C22.9228 15.0224 23.0726 14.7611 23.3499 14.6186Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0809 12.602C26.329 12.6021 26.5302 12.6889 26.5301 12.7959L26.5292 15.1213C26.5292 15.2283 26.328 15.315 26.0798 15.3149C25.8317 15.3148 25.6305 15.2279 25.6306 15.1209L25.6315 12.7956C25.6315 12.6886 25.8327 12.6019 26.0809 12.602Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7242 13.9586C24.7242 13.7104 24.811 13.5093 24.918 13.5093H27.2433C27.3503 13.5093 27.4371 13.7104 27.4371 13.9586C27.4371 14.2068 27.3503 14.4079 27.2433 14.4079H24.918C24.811 14.4079 24.7242 14.2068 24.7242 13.9586Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3879 17.8164C22.3879 17.5801 22.4578 17.3885 22.544 17.3885H24.4176C24.5038 17.3885 24.5737 17.5801 24.5737 17.8164C24.5737 18.0528 24.5038 18.2444 24.4176 18.2444H22.544C22.4578 18.2444 22.3879 18.0528 22.3879 17.8164Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8315 21.6888C16.8315 21.2753 17.3023 20.9402 17.8831 20.9402H30.5024C31.0832 20.9402 31.554 21.2753 31.554 21.6888C31.554 22.1022 31.0832 22.4374 30.5024 22.4374H17.8831C17.3023 22.4374 16.8315 22.1022 16.8315 21.6888Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8313 25.2428C16.8313 24.8294 17.3021 24.4942 17.8829 24.4942H30.5023C31.0831 24.4942 31.5539 24.8294 31.5539 25.2428C31.5539 25.6563 31.0831 25.9914 30.5023 25.9914H17.8829C17.3021 25.9914 16.8313 25.6563 16.8313 25.2428Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8313 28.7967C16.8313 28.3832 17.3021 28.0481 17.8829 28.0481H30.5023C31.0831 28.0481 31.5539 28.3832 31.5539 28.7967C31.5539 29.2102 31.0831 29.5453 30.5023 29.5453H17.8829C17.3021 29.5453 16.8313 29.2102 16.8313 28.7967Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8313 32.3507C16.8313 31.9373 17.3021 31.6021 17.8829 31.6021H30.5023C31.0831 31.6021 31.5539 31.9373 31.5539 32.3507C31.5539 32.7642 31.0831 33.0993 30.5023 33.0993H17.8829C17.3021 33.0993 16.8313 32.7642 16.8313 32.3507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalMarks);
export default __webpack_public_path__ + "static/media/total-marks.254fc12c38b209081e3e26c2ce41bbab.svg";
export { ForwardRef as ReactComponent };